import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";
import { MAX_SERVER_REQUESTS_ERROR, MEMBER_NOT_FOUND } from "./OtpVerifyRegisterWithBankAccount";



export async function OtpSend(
    userId: string,
    _otpMode: number,
    _cellPhoneNumber: string,
    userEmail: string
) {
    if (userId && userId.length) {
        try {
            const body = {
                memberID: userId,
                otpMode: _otpMode,
                cellPhoneNumber: _cellPhoneNumber,
                email: userEmail,
                language: getLangNumber()
            };
            const path = environment.BASE_URL + "MemberLogin/OTPSend";
            const res: AxiosResponse<any> = await axios.post(path, body);
            if (axiosUtil.isSuccess(res)) return true;
            // handle max server case
            if (res?.data?.errorCode === 36) return MAX_SERVER_REQUESTS_ERROR;
            if (res?.data?.errorCode === 21) return MEMBER_NOT_FOUND;

            return false;
        } catch (err) {
            console.log(err);
        }
    }
    return false;
}

const getLangNumber = () => {
    switch (localStorage.getItem("lang")) {
        case 'he':
            return 0
        case 'ar':
            return 1
        case 'en':
            return 2
    }
}


export const otpSendUtil = {
    isSuccess: (isOtpSended: boolean | string) => {
        if (isOtpSended === MEMBER_NOT_FOUND)
            return null
        return typeof isOtpSended === "boolean" && isOtpSended
    }
    ,

    isMaxServerRequestsError: (isOtpSended: boolean | string) =>
        typeof isOtpSended === "string" &&
        isOtpSended === MAX_SERVER_REQUESTS_ERROR,
};
